import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { request } from "../../utils/axios-utils";
import { USER_AUTH } from "../../utils/constants";
import Cookies from "js-cookie";

const LogoutButton = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const logout = () => {
    if (window.confirm("Вы уверены что хотите выйти?")) {
      Cookies.remove(USER_AUTH);
      request({ url: "api/v2/logout/yandex", method: "post" })
        .then(() => {
          navigate("/login");
        })
        .catch((err) => {
          console.error(err.message);
        });
    }
  };
  return <Logout onClick={() => logout()}>{t("logout")}</Logout>;
};

export default LogoutButton;

const Logout = styled.button`
  border: none;
  height: 100%;
  background: none;
  padding: 0 1.1em;
  color: #222;
  font-weight: 500;
  font-size: 15px;
  align-items: center;
  justify-content: center;
  display: flex;
  border-bottom: 3px solid transparent;
  transition: all 220ms ease-in-out;
  :hover {
    border-bottom: 3px solid #e43a3a;
  }

  cursor: pointer;
`;
